import React from "react";
import { cn } from "../../utils/cn";

const Spinner = ({ className }) => {
  return (
    <div
      className={cn(
        "animate-spin rounded-full h-3 w-3 border-b-2 !border-primary",
        className
      )}
    />
  );
};

export default Spinner;
